import _this from "../../main";
import router from '../../router'
import moment from 'moment'

export default {
  install(Vue) {

    //================ 用户校验相关

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (senceqrcode, userinfosessionKey, redirect, callback){
      // console.log(senceqrcode)
      // console.log(userinfosessionKey)
      // console.log(redirect)
      // console.log(callback)
      // return false;
      redirect = redirect ? decodeURIComponent(redirect) : undefined;

      // localStorage.removeItem('giant_userdata');

      _this.axios.post(_this.$store.state.api.new_login_api + '/api/sso/checkLoginNew', _this.qs.stringify({
        sessionKey: userinfosessionKey
      })).then(function(res){
      // _this.axios.get(_this.$store.state.api.login_api + '/checkLogin', {
      //   params:{sessionKey: userinfosessionKey}
      // }).then(function(res){

        // console.log(res);


        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$router.replace({ path: '/login', query: { redirect: redirect }});
              console.error(error);
              return false;
            }
          }

          if( res.data.status == '1' ){
            if( res.data.data._status ){
              const fetch_data = res.data.data;


              if( fetch_data.isgiant == 1 ){
                let user_data = {};

                let role_name = '';

                fetch_data._auth.forEach(function(item_n){

                  if( item_n.type_id == 2 ){
                    role_name = item_n.role_name
                  }

                });

                // console.log(fetch_data);
                // return false
                if( fetch_data._ssoOrg ){

                  let org_id = fetch_data._ssoOrg.orgId;
                  fetch_data._org.map(item => {
                    if(item.id == org_id){
                      user_data = {
                        role_name: role_name,
                        usercode: item.natureCode,

                        orgId: org_id, //上一次切换节点id
                        //id: item.id, // 当前身份登录组织节点id
                        id: fetch_data._user.id, //老系统的userid

                        isDept: item.isDept, //0 节点 （sbu、经销商、门店） // 1是部门 (销售部 ，财务部)
                        role: item.natureCode,
                        roleCode: item.code,
                        nature_id: item.natureId,
                        sessionkey: fetch_data.sessionKey,
                        name: item.name, //当前名称

                        parentId: item.parentId, //父级的ID
                        dealerCode: item.dealerCode, //如果当前角色是门店，经营报告页面调用接口需要传所属的经销商code
                        sbucode: item.sbuCode, //sbucode
                        dealercode: item.dealerCode,
                        dealerId: item.dealerId,
                        dealerName: item.dealerName,
                        shopno: item.storeCode,
                        mainOrgCode: item.mainOrgCode, // 最顶层部门的节点数据
                        mainOrgId: item.mainOrgId,
                        mainOrgName: item.mainOrgName,

                        manager: item.manager, //当前角色所在部门的负责人信息
                        managerId: item.managerId,
                        managerName: item.managerName,

                        orgs: item.orgs, //当前登录的大节点下面有哪些部门
                        staffId: item.staffId,
                        staffName: fetch_data._staff.name,
                        username: fetch_data._user.username,
                        nickname: fetch_data._user.nickname ? fetch_data._user.nickname : '无昵称',
                        avatar: fetch_data._user.user_img,
                        phone: fetch_data._user.phone_number,
                        email: fetch_data._user.email,
                      }

                      if( item.natureCode == 'master' ){
                      }else if( item.natureCode == 'sbu' ){

                        user_data.sbucode = item.code;
                      }else if( item.natureCode == 'dealer' ){

                        user_data.dealercode = item.code;
                      }else if( item.natureCode == 'store' ){

                        user_data.shopno = item.code;
                      }

                      user_data.name = user_data.username?user_data.username:user_data.nickname;
                    }
                  })
                }else{

                  fetch_data._org.map(function(item, index) {

                    if( !_this.$store.state.browser.giantopoapp && index==0 ){

                      user_data = {
                        role_name: role_name,
                        usercode: item.natureCode,

                        orgId: item.id, //上一次切换节点id
                        //id: item.id, // 当前身份登录组织节点id
                        id: fetch_data._user.id, //老系统的userid

                        isDept: item.isDept, //0 节点 （sbu、经销商、门店） // 1是部门 (销售部 ，财务部)
                        role: item.natureCode,
                        roleCode: item.code,
                        nature_id: item.natureId,
                        sessionkey: fetch_data.sessionKey,
                        name: item.name, //当前名称

                        parentId: item.parentId, //父级的ID
                        dealerCode: item.dealerCode, //如果当前角色是门店，经营报告页面调用接口需要传所属的经销商code

                        sbucode: item.sbuCode, //sbucode
                        dealercode: item.dealerCode,
                        dealerId: item.dealerId,
                        dealerName: item.dealerName,
                        shopno: item.storeCode,
                        mainOrgCode: item.mainOrgCode, // 最顶层部门的节点数据
                        mainOrgId: item.mainOrgId,
                        mainOrgName: item.mainOrgName,

                        manager: item.manager, //当前角色所在部门的负责人信息
                        managerId: item.managerId,
                        managerName: item.managerName,

                        orgs: item.orgs, //当前登录的大节点下面有哪些部门
                        staffId: item.staffId,
                        staffName: fetch_data._staff.name,
                        username: fetch_data._user.username,
                        nickname: fetch_data._user.nickname ? fetch_data._user.nickname : '无昵称',
                        avatar: fetch_data._user.user_img,
                        phone: fetch_data._user.phone_number,
                        email: fetch_data._user.email,
                      }

                      if( item.natureCode == 'master' ){
                      }else if( item.natureCode == 'sbu' ){

                        user_data.sbucode = item.code;
                      }else if( item.natureCode == 'dealer' ){

                        user_data.dealercode = item.code;
                      }else if( item.natureCode == 'store' ){

                        user_data.shopno = item.code;
                      }

                      user_data.name = user_data.username?user_data.username:user_data.nickname;
                    }
                  })
                }

                if( user_data.role == 'store' ){
                  user_data.roletype = 0;//门店
                }else{
                  user_data.roletype = 1;//车主会员
                }

                if( !user_data.id ){
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: '通知',
                    message: '当前账号出现异常，请联系相关管理员',
                    showCancelButton: false,
                    confirmButtonText: '我知道了',
                  }).then(() => {
                    if( _this.$store.state.browser.giantopoapp ){
                      if( _this.$store.state.browser.ios ){
                        window.webkit.messageHandlers.back.postMessage('');
                      }else{
                        android.back();
                      }
                    }else{
                      _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                    }
                  }).catch(() => {
                  });
                  // _this.$toast('当前角色无权限登录该系统，请检查账号');
                  return false;
                }

                callback && callback();

                //本地存储
                user_data.isgiant = fetch_data.isgiant
                user_data.origin_org = fetch_data._org || []
                localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
                //sessionStorage.setItem('user_','#/IndexA');
                //console.log(redirect)
                //_this.$router.replace({ path: '/'});


                if( redirect ){
                  // console.log(redirect);
                  // return false;
                  location.replace(redirect);
                  return false;
                }
                if( senceqrcode ){
                  _this.$router.replace({ name: 'Index', query: {qrcode: senceqrcode}});
                  return false;
                }

                _this.$router.replace({ path: '/'});
              }else{
                var usercode = '';
                let role_name = '';

                fetch_data._auth.forEach(function(item_n){

                  if( item_n.type_id == 2 ){
                    role_name = item_n.role_name
                  }

                  if( item_n.type_id == 1 && item_n.role_code == "storeManager" ) {
                    usercode = 'store';
                  }else if( item_n.type_id == 1 && item_n.role_code == "employee" ) {
                    usercode = 'store';
                  }

                });

                let user_data = {
                  sessionkey: fetch_data.sessionKey,
                  usercode: usercode,
                  roleCode: '',
                  id: fetch_data._user.id,
                  username: fetch_data._user.username,
                  nickname: fetch_data._user.nickname ? fetch_data._user.nickname : '无昵称',
                  role_name: role_name,
                  phone: fetch_data._user.phone_number,
                  email: fetch_data._user.email,
                  //name: fetch_data.realname,
                  avatar: fetch_data._user.user_img,

                  service_shopno: fetch_data._user.shopNo,//服务门店
                  service_dealer: fetch_data._user.dealerCode,
                  service_sbu: fetch_data._user.sbuCode,

                  sbucode: fetch_data._user.bindSbuCode,
                  dealercode: fetch_data._user.bindDealerCode,
                  shopno: fetch_data._user.bindShopNo,
                  //roletype: 1,//经销商
                }

                if( user_data.usercode == 'sbu' ){
                  user_data.roleCode = user_data.sbucode;
                }else if( user_data.usercode == 'dealer' ){
                  user_data.roleCode = user_data.dealercode;
                }else if( user_data.usercode == 'store' ){
                  user_data.roleCode = user_data.shopno;
                }

                user_data.name = user_data.username?user_data.username:user_data.nickname;

                if( user_data.shopno ){
                  user_data.roletype = 0;//门店
                }

                // fetch_data._auth.forEach(function(item_goods){
                //     if(item_goods.role_code == "master"){
                //       user_data.roletype = 2;//总部
                //     }
                // });
                if( !user_data.usercode ){
                  user_data.roletype = 1;//车主会员
                }

                //本地存储
                user_data.origin_org = fetch_data._org || []
                user_data.isgiant = fetch_data.isgiant
                localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
                //sessionStorage.setItem('user_','#/IndexA');

                //读取
                //console.log( localStorage.getItem('user_data') );
                //console.log( JSON.parse(localStorage.getItem('user_data')) );

                callback && callback();

                if( redirect ){
                  // console.log(redirect);
                  // return false;
                  location.replace(redirect);
                  return false;
                }
                if( senceqrcode ){
                  _this.$router.replace({ name: 'Index', query: {qrcode: senceqrcode}});
                  return false;
                }

                _this.$router.replace({ path: '/'});
              }







              //读取
              //console.log( localStorage.getItem('user_data') );
              //console.log( JSON.parse(localStorage.getItem('user_data')) );



            } else {
              //_this.$toast('更新令牌出现了一些问题');

              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '通知',
                message: '当前账号出现异常，请联系相关管理员',
                showCancelButton: false,
                confirmButtonText: '我知道了',
              }).then(() => {
                if( _this.$store.state.browser.giantopoapp ){
                  if(_this.$store.state.browser.ios ){
                    window.webkit.messageHandlers.back.postMessage('');
                  }else{
                    android.back();
                  }
                }else{
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                }
              }).catch(() => {
              });
            }
          }else{
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: res.data.msg ? res.data.msg : '自动登录失败',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              if( _this.$store.state.browser.giantopoapp ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: redirect }});
              }
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
            }).catch((err) => {
              console.log(err)
              history.back();
              // _this.$router.replace({ path: '/login', query: { redirect: location.href } });
            });

            // console.error(res.data.msg ? res.data.msg : '自动登录失败——2');
            // _this.$router.replace({ path: '/login', query: { redirect: redirect }});
          }

        } else {
          console.error(res.data.msg ? res.data.msg : '自动登录失败——2');
          _this.$router.replace({ path: '/login', query: { redirect: redirect }});
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_this.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        _this.$router.replace({ path: '/login', query: { redirect: redirect }});
        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_this.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    }

    //刷新sessionKey（token） 全局函数
    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = function (callback, sorryFn){


      //如果在App环境中，调用App的刷新Token方法
      if( _this.$store.state.browser.giantopoapp ){

        let _token = '';

        if( _this.$store.state.browser.ios ){
          _token = window.webkit.messageHandlers.opoOC.getToken();
        } else {
          _token = android.getToken();
        }

        let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

        user_data.sessionkey = _token;
        //本地存储
        localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

        _this.$store.commit('updateLoginUser', user_data);
        return false;
      }

      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)

      _this.axios.post(_this.$store.state.api.new_login_api + '/api/sso/refreshLoginNew', _this.qs.stringify({
        sessionKey: _this.$store.state.loginUser.sessionkey
      })).then(function(res){

        // console.log(res);

        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              console.error(error);
              if( sorryFn ){
                if( typeof sorryFn == "function" ){
                  sorryFn();
                } else {
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.data.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                    _this.$router.replace({ path: '/login', query: { redirect: location.href }});
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data.status == '1') {
            if( res.data.data._status ){
              // console.log(res)
              let user_data = JSON.parse(localStorage.getItem('giant_userdata'));

              user_data.sessionkey = res.data.data.sessionKey;
              //本地存储
              localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

              _this.$store.commit('updateLoginUser', user_data);

              //const fetch_data = res.data.data;
              //console.log(fetch_data);
              if (typeof callback == "function") {
                setTimeout(function () {
                  callback();
                }, Math.ceil(Math.random() * 500));//增加<500毫秒的延时
              }
            }else{
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              return false;
            }


          } else {
            //_this.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg ? res.data.msg : '登录失效',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  showCancelButton: false
                }).then(() => {
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                }).catch(() => {
                  history.back();
                });
              }
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: res.data.msg ? res.data.msg : '登录失效',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                showCancelButton: false
              }).then(() => {
                _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
              }).catch(() => {
                history.back();
              });
            }
          }

        } else {

          if( sorryFn ){
            if( typeof sorryFn == "function" ){
              sorryFn();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '登录失效',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                _this.$router.replace({ path: '/login', query: { redirect: location.href }});
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if( sorryFn ){
          if( typeof sorryFn == "function" ){
            sorryFn();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '登录失效',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
              _this.$router.replace({ path: '/login', query: { redirect: location.href }});
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };

    //判断骑行App版本 atleast 至少
    Vue.prototype.checkGiantAppVersion = function (limit_giantappversion, atleast){

      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      if( history.length > 1 ){
        router.go(-1);
      } else {
        router.push({path: '/'});
      }
    };

    //返回(新)
    Vue.prototype.goToPrevpage = function () {
      if( _this.$store.state.browser.giantopoapp ){
        if( _this.$store.state.browser.ios ){
          window.webkit.messageHandlers.back.postMessage('');
        }else{
          android.back();
        }
      }else{
        if (history.length > 1) {
          router.go(-1);
        } else {
          router.push({
            path: '/'
          });
        }
      }

    };
    Vue.prototype.closeApp = function (){
      if (_this.$store.state.browser.giantapp) {
        if (_this.$store.state.browser.ios) {
            window.webkit.messageHandlers.closeWebView.postMessage('');
        } else {
            android.closeWebView();
        }
      } else {
        _this.$router.go(-1);
      }
    },

    //关闭qrcode系统
    Vue.prototype.closePrevpage = function () {
      if( _this.$store.state.browser.ios ){
        window.webkit.messageHandlers.closeWebView.postMessage('');
      } else {
        android.closeWebView();
      }
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content){

      const textString = content.toString();//数字没有 .length 不能执行selectText 需要转化成字符串
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }

      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        //alert('已复制到粘贴板');
      }
      input.blur();

      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }

      /*
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
      */
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false){
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if( linear ){
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step (newTimestamp) {
          if ( firstTimestamp === null ){
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step (newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2){
      function Rad(d){
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var  b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
      Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
      s = s *6378.137 ;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError){


      if( !mustReFresh ){//非强制刷新
        let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
        if( tmpUserpostion && tmpUserpostion.lat ){
          fnCallback && fnCallback(tmpUserpostion);
        } else {
          _this.getUserPostion( true, fnCallback, fnError );
        }
        return false;
      }

      window.onGaodeLoad = function(){
        _this.getUserPostion( mustReFresh, fnCallback, fnError );
      }
      if( typeof(AMap) =="undefined" ){
        var url = 'https://webapi.amap.com/maps?v=2.0&key=90bc3da9e0445dd5885581a43922d93c&callback=onGaodeLoad';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        document.head.appendChild(jsapi);
      } else {
        let map, geolocation;
        map = new AMap.Map(document.createElement('div'), {
          //resizeEnable: true
        });
        map.plugin('AMap.Geolocation', function() {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          geolocation.getCurrentPosition(function(status, result){
            if(status=='complete'){
              //console.log(result.position);

              let userpostion_data = {
                lat: result.position.getLat(),//高精 //result.position.lat
                lng: result.position.getLng(),//高精 //result.position.lng
              }
              //console.log(userpostion_data);

              //本地存储
              localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

              fnCallback && fnCallback(userpostion_data);

            } else {
              //onError(result)
              //alert(2);
              fnError && fnError(result);
            }
          });
        });

      }


    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function(num, fixed = 2, round = true, thousand = false){
      if( isNaN(num) ){
        return num;
      }
      if( fixed >= 0 ){
        if(round){
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if( thousand ){
        var numarr = num.split(".");
        if( numarr.length ) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if( numarr.length > 1 && numarr[1]!="" ) {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+'){

      if( mode == '-' ){//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if( mode == '*' ){//=========================
        let c = 0,
        d = a.toString(),
        e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) {}
        try {
          c += e.split('.')[1].length;
        } catch (f) {}
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if( mode == '/' ){//=========================
        let c, d, e = 0,f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) {}
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) {}
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间戳
    Vue.prototype.dateformat = function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss'){
      if( dataStr.toString().length < 13 ){
        dataStr *= 1000;
      }
      return moment(dataStr).format(pattern);
    };

    //base64转Blob
    Vue.prototype.dataURItoBlob = function (dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    //压缩图片
    //width 宽、height 高、quality 质量、longside 长边（优先级高过宽高）、shortside 短边（优先级最高）
    Vue.prototype.compressImage = function (file, callback, config){

      if (file.type == 'image/gif' || file.type == 'image/jpeg' || file.type == 'image/pjpeg' || file.type == 'image/png' || file.type == 'image/x-png') {

        let tmpParams = {
          width: 1000,
          quality: 0.8
        };

        tmpParams = Object.assign(tmpParams, config);

        //通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        var img = new Image;
        reader.onload = function (e) {
          //var width = 1080; //图像大小
          //var quality = 0.8; //图像质量
          var canvas = document.createElement("canvas");
          var drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;

            if( tmpParams.shortside ){
              if( img.width > img.height ){
                tmpParams.height = tmpParams.shortside;
                tmpParams.width = tmpParams.height * (img.width / img.height);
              } else if( img.height > img.width ){
                tmpParams.width = tmpParams.shortside;
                tmpParams.height = tmpParams.width * (img.height / img.width);
              }
            }else if( tmpParams.longside ){
              tmpParams.width = tmpParams.height = tmpParams.longside;
            }
            if( tmpParams.width && tmpParams.width < img.width ){
              canvas.width = tmpParams.width;
              canvas.height = tmpParams.width * (img.height / img.width);
            }
            if( tmpParams.height && tmpParams.height < canvas.height ){
              canvas.height = tmpParams.height;
              canvas.width = tmpParams.height * (img.width / img.height);
            }
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            let tmpType = 'image/jpeg';
            if( file.file.type == 'image/png' || file.file.type == 'image/x-png' ){
              tmpType = 'image/png';
            }
            file.file = new window.File([_this.dataURItoBlob(canvas.toDataURL(tmpType, tmpParams.quality))], file.file.name, {type: file.file.type});
            callback && callback(file);
          }
        }
      } else {
        callback && callback(file);
      }
    };
    // 上传图片开始
    Vue.prototype.compressImgNew = function(fileObj) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(fileObj);
        reader.onload = function (e) {
          let image = new Image(); //新建一个img标签（不嵌入DOM节点，仅做canvas操作)
          image.src = e.target.result; //让该标签加载base64格式的原图
          image.onload = function () {
            //图片加载完毕后再通过canvas压缩图片，否则图片还没加载完就压缩，结果图片是全黑的
            let canvas = document.createElement("canvas"), //创建一个canvas元素
              context = canvas.getContext("2d"), //context相当于画笔，里面有各种可以进行绘图的API
              imageWidth = image.width / 2, //压缩后图片的宽度，这里设置为缩小一半
              imageHeight = image.height / 2, //压缩后图片的高度，这里设置为缩小一半
              data = ""; //存储压缩后的图片
            canvas.width = imageWidth; //设置绘图的宽度
            canvas.height = imageHeight; //设置绘图的高度

            //使用drawImage重新设置img标签中的图片大小，实现压缩。drawImage方法的参数可以自行查阅W3C
            context.drawImage(image, 0, 0, imageWidth, imageHeight);
            //使用toDataURL将canvas上的图片转换为base64格式
            data = canvas.toDataURL("image/png");
            canvas.toBlob(function (blob) {
              const f = new File([blob], fileObj.name, { type: "image/png" });
              resolve(f);
            }, "image/png");
          };
        };
      });
    },

    //初始化微信分享
    Vue.prototype.funWxShare = function (shareConfig={}){


      if(_this.$store.state.browser.wx) {

        let tmpParams = {
          re_url: location.href,//_this.$store.state.siteUrl,//分享链接URL
        }

        //对 iOS 特殊处理
        if(_this.$store.state.browser.ios) {
          if(!sessionStorage.getItem('firsttouch4ios')){//将入口地址保存下来，iOS 分享会使用
            sessionStorage.setItem('firsttouch4ios', window.location.href);
          }
          tmpParams.re_url = sessionStorage.getItem('firsttouch4ios');
        }

        _this.axios.post(_this.$store.state.api.common + 'api/get_wx_sign', _this.qs.stringify(tmpParams)).then(function(res){

          if( res.status == 200 ){
            if( typeof res.data != "object" ){
              res.data = JSON.parse(res.data);
            }
            if( res.data.status == 1 ){//

              const fetch_data = res.data.data;

              let json_config = {
                debug: false,
                appId: fetch_data.appId,//_this.$store.state.wxAppId
                timestamp: fetch_data.timestamp ? fetch_data.timestamp : 1,
                nonceStr: fetch_data.nonceStr ? fetch_data.nonceStr : '',
                signature: fetch_data.signature ? fetch_data.signature : '',
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData']
              }

              wx.config(json_config);

              //console.log(json_config);

              wx.error(function(res) {
              });
              wx.ready(function () {
                var shareData = {
                  title: '捷安特官方商城 | 专业自行车服务',
                  desc: '捷安特官方商城是捷安特公司精心为用户打造的自行车购物及服务平台',
                  link: location.href,
                  imgUrl: _this.$store.state.siteUrl+'/static/img/share_logo.png',
                  success: function (res) {
                  },
                  cancel: function (res) {
                  }
                };

                shareData = Object.assign(shareData, shareConfig);

                wx.onMenuShareTimeline(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
              });
              //alert('这代表可以分享了');
            } else if( res.data.status == 0 ){
              _this.$toast(res.data.msg);
            } else {
              _this.$toast('出现了一些问题');
            }

          } else {
            _this.$toast('请求失败');
          }

        }).catch(function (error) {
          _this.$toast('失败');
          console.log(error);
        });

      }

    };


    //判断字符串中是否有超过2字节的字符（是否有emoji表情）
    Vue.prototype.is32Bit = function (substring) {
      for (var i = 0; i < substring.length; i++) {
        if( substring.codePointAt(i) > 0xFFFF){
          return true;
        }
      }
      return false;
    };

    //判断字符串中多少个字节
    Vue.prototype.stringByteCount = function (substring) {
      if(!arguments.length||!substring) return null;
      if(''==substring) return 0;
      var l=0;
      for(var i=0;i<substring.length;i++){
        if(substring.charCodeAt(i)>255) l+=2;
        else l++;
      }
      return l;
    };
    //================ 业务相关

    //行为埋点
    Vue.prototype.setBehaviorPoint = function (json){


      //return false;//埋点先关掉

      let tmpParams = {
        SYS: 'SHOP',//平台code
        PAGE: '',//PAGE 来源对照表https://docs.qq.com/sheet/DSUZHWEJBWFhqSHN1?tab=BB08J2
        PID: '',//如果是商品传商品id
        title: document.title,
        action: '',//A1 页访
        VAL: 1,
        info: document.title ? document.title : '官方商城',
        UserID: '',
        shopno: '',
        deviceId: '',//设备ID，目前没有用到可以传空
        objCode: 0,//0 无  1商品  2活动 3新闻
      }

      tmpParams = Object.assign(tmpParams, json);

      _this.axios.post(_this.$store.state.api.common + 'behavior/send_behavior_json', _this.qs.stringify(
        tmpParams
      )).then(function(res){
      }).catch(function (error) {
      });
    };
    //SCRM 行为埋点
    Vue.prototype.setBehaviorPointScrm = function (json){
    const userId = this.$store.state.loginUser.id || (localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).id : '' )
    if(userId && userId != ''){
      let tmpParams = {
        sku:json.sku,
        uid: userId,
        duration: json.duration,
        page:json.page,
        name:json.name
      }
      console.log(tmpParams, '====埋点')
      _this.axios.post(_this.$store.state.api.qrcode_api + '/front/viewQRcode', _this.qs.stringify(tmpParams)).then(function(res){
      }).catch(function (error) {
      });
    }
    };
    Vue.prototype.judgeType = function (ele) {
      let res = typeof ele
      if (res === 'object') {
        // 短路表达式，第一个成立则返回第二个的值，第一个不成立，则返回第一个的值
        Object.prototype.toString.call(ele) === '[object Object]' && (res = 'object')
        Object.prototype.toString.call(ele) === '[object Array]' && (res = 'array')
        Object.prototype.toString.call(ele) === '[object Date]' && (res = 'date')
        Object.prototype.toString.call(ele) === '[object Null]' && (res = 'null')
        Object.prototype.toString.call(ele) === '[object RegExp]' && (res = 'RegExp')
      }
      return res
    }
    Vue.prototype.getUrlParam = function (url, name) {
      url = url || window.location.href
      let params = url.substr(url.lastIndexOf('?') + 1).split('&')
      for (let i = 0; i < params.length; i++) {
        let param = params[i]
        let key = param.split('=')[0]
        let value = param.split('=')[1]
        if (key === name) {
          return value
        }
      }
    }
    Vue.prototype.isValidJSON = function (jsonString) {
      try {
        JSON.parse(jsonString)
      } catch (e) {
        return false
      }
      return true
    }




  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js